import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import type { PatientProfileTab } from '@elva/ui';
import { patientProfilePath } from '../utils/patientProfileRoutes';

/** `?tab=treatments` from the call list and the agent page (staging fix 29 §5). */
const TAB_QUERY: Record<string, PatientProfileTab> = {
  profile: 'Profile',
  communications: 'Communications',
  treatments: 'Treatments',
  insurance: 'Insurance',
  forms: 'Forms',
  invisalign: 'Invisalign',
};

/** `/patients/:patientId` → `/patients/:patientId/Profile`, unless `?tab=` names one. */
export function PatientProfileTabRedirect() {
  const { patientId } = useParams<{ patientId: string }>();
  const [params] = useSearchParams();
  if (!patientId) return <Navigate to="/patients" replace />;
  const tab = TAB_QUERY[(params.get('tab') ?? '').toLowerCase()] ?? 'Profile';
  return <Navigate to={patientProfilePath(patientId, tab)} replace />;
}
